// extracted by mini-css-extract-plugin
module.exports = {"recommendedTitle":"recommendedReplyCard_recommendedTitle__3MIiw","recommendedBtn":"recommendedReplyCard_recommendedBtn__2ZGA9"};